import { Component } from '@angular/core';
import { CarLinerProductGridViewComponent } from '../car-liner-product-grid-view/car-liner-product-grid-view.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'car-liner-included-items-grid-view',
    templateUrl: './car-liner-included-items-grid-view.component.html',
    styleUrls: ['./car-liner-included-items-grid-view.component.scss'],
    standalone: false
})
export class CarLinerIncludedItemsGridViewComponent extends CarLinerProductGridViewComponent {
  public isJosam: boolean = environment.projectName === 'josam';
}
